import React from 'react';
import { PULSE_CHECK_CATEGORY_ICON_MAP, PulseCheckCategory } from './ActionStepsV2.meta';
import { Text } from '../../CommonComponents/OPL/Text/Text';

interface Props {
  category: PulseCheckCategory;
}

export const PulseCheckCategoryIcon = ({ category }: Props) => {
  const Icon = PULSE_CHECK_CATEGORY_ICON_MAP[category];

  return (
    <Text color="#572A79" width={24}>
      <Icon />
    </Text>
  );
};
